<template>
  <div>
    <div class="form-group">
      <h5 class="section-title">
        Preview Type
      </h5>
      <div class="kt-radio-inline">
        <label v-if="example_item" class="kt-radio">
          <input v-model="preview_type" value="item"
                 type="radio"
                 name="preview_type_item"> {{ getItemLabel(true) }}
          <span />
        </label>
        <span v-else>
          <br>You don't have any items. Add an item to preview.
        </span>
        <label v-if="example_feed" class="kt-radio">
          <input v-model="preview_type" value="feed"
                 type="radio"
                 name="preview_type_feed"> {{ getFeedLabel(true) }}
          <span />
        </label>
        <span v-else>
          <br>You don't have any feeds with published {{ getItemLabel() }}s. Add a {{ getFeedLabel(true) }}s with publish items to preview.
        </span>
      </div>
      <span class="form-text text-muted" />
    </div>
    <embed-generator v-if="player_url" :is-feed="is_feed" :player-url="player_url" />
  </div>
</template>

<script>
import EmbedGenerator from "VuePartials/EmbedGenerator";
export default {
  components: { EmbedGenerator },
  data() {
    return {
      example_item: window.embed_theme_item,
      example_feed: window.embed_theme_feed,
      preview_type: 'item',
    };
  },
  computed: {
    is_feed() {
      return this.preview_type === 'feed';
    },
    player_url() {
      if (this.is_feed && this.example_feed) {
        return this.example_feed.player_data.basic_url;
      }

      if (this.example_item) {
        return this.example_item.player_data.basic_url;
      }

      return null;
    },
  },
  watch: {
    preview_type: function () {
      EventBus.$emit('embed_preview_type_updated');
    },
  },
};
</script>

<style lang="scss" scoped>
  .section-title {
    padding-bottom: 0.5rem !important;
    margin-bottom: 1.5rem !important;
    border-bottom: 1px solid rgb(235, 236, 241);
  }
</style>
